import { AbilityBuilder, PureAbility } from '@casl/ability';
import Region from '../../../../constants/region';
import { ManageRapidTest } from '../../../../custom-widgets/PermissionsSelector/config/permissions';
import { isSuperUser } from '../../../../../utils';

function DropoffRapidTestPermissions(user) {
    const { can, rules } = new AbilityBuilder(PureAbility);
    const {
        role,
        data: { region, subuser, permissions },
    } = user;

    // Only IMP sub-processors with the ManageRapidTest permission can mutate completed dropoff rapid tests
    if ([Region.IMP].includes(region) && (isSuperUser() || (role === 'processor' && !!subuser && permissions.includes(ManageRapidTest.value)))) {
        can('mutate', 'dropoff_rapid_test');
    }

    return rules;
}

export default DropoffRapidTestPermissions;
